import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Aplicacion from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Aplicacion />
    </BrowserRouter>,
);

reportWebVitals();
